import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCommonStore from './common-store.reducer';

export const selectCommonStoreState =
    createFeatureSelector<fromCommonStore.State>(
        fromCommonStore.commonStoreFeatureKey
    );

export const selectHelpLinks = createSelector(
    selectCommonStoreState,
    (state: fromCommonStore.State) => state.helpLinks
);

export const selectConstants = createSelector(
    selectCommonStoreState,
    (state: fromCommonStore.State) => state.constants
);

export const selectNuclides = createSelector(
    selectCommonStoreState,
    (state: fromCommonStore.State) => state.nuclides
);
